(() => {
  const patchProductInfo = () => {
    const ProductInfo = customElements.get('product-info');
    const prototype = ProductInfo?.prototype;
    if (
      !prototype ||
      prototype.zyvoriaSizeScrollGuard ||
      typeof prototype.handleOptionValueChange !== 'function' ||
      typeof prototype.updateMedia !== 'function'
    ) {
      return;
    }

    const handleOptionValueChange = prototype.handleOptionValueChange;
    const updateMedia = prototype.updateMedia;

    prototype.handleOptionValueChange = function handleZyvoraOptionValueChange(payload) {
      const eventTarget = payload?.data?.event?.target;
      this.zyvoriaSuppressVariantMediaScroll = Boolean(
        eventTarget?.closest?.('.selector-wrapper--size'),
      );
      return handleOptionValueChange.call(this, payload);
    };

    prototype.updateMedia = function updateZyvoraVariantMedia(mediaId) {
      if (!this.zyvoriaSuppressVariantMediaScroll) {
        return updateMedia.call(this, mediaId);
      }

      const variantImageScroll = this.variantImageScroll;
      this.variantImageScroll = false;
      const result = updateMedia.call(this, mediaId);

      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          this.variantImageScroll = variantImageScroll;
          this.zyvoriaSuppressVariantMediaScroll = false;
        });
      });

      return result;
    };

    prototype.zyvoriaSizeScrollGuard = true;
  };

  if (customElements.get('product-info')) {
    patchProductInfo();
  } else {
    customElements.whenDefined('product-info').then(patchProductInfo);
  }
})();
